import React from "react";
import styles from "./styles.module.scss";
import { formatNumberWithNoun } from "src/utils/utils";
import { HebrowNouns, INPUT_SPECIAL_TYPE } from "src/utils/enums";
import { UIRadioBtn, UIText } from "../uIKit";

interface RadioBtnBannerProps {
  name: string;
  title: string;
  subTitle: string;
  index: number;
  isChecked: boolean;
  onCheckboxChange: (index: number) => void;
  isHidden?: boolean;
}

const RadioBtnBanner: React.FC<RadioBtnBannerProps> = ({
  name,
  title,
  subTitle,
  index,
  isChecked,
  onCheckboxChange,
  isHidden = false,
}) => {

  const handleCheckboxChange = () => {
    onCheckboxChange(index);
  };

  return (
    <div className={styles.cardItem}>
      <UIRadioBtn
        isHidden={isHidden}
        key={`${INPUT_SPECIAL_TYPE.RADIO}-${name}-${index}`}
        ariaLabel={`${formatNumberWithNoun(index, HebrowNouns.OPTION)} ${title} ${subTitle}`}
        checked={isChecked}
        onChange={handleCheckboxChange}
        name={`${INPUT_SPECIAL_TYPE.RADIO}-${name}`}
        value={index.toString()}
      />
      <div className={styles.cardDetails}>
        <UIText text={title} size={18} weight={500} isAriaHidden={isHidden} />
        <UIText text={subTitle} size={15} weight={400} isAriaHidden={isHidden} />
      </div>
    </div>
  );
};

export default RadioBtnBanner;
